<app-layout>
    <div class="reports-list-page">
        <mat-toolbar class="page-header" role="heading">
            <div class="page-header-title">
                <div class="page-header-copy">
                    <span class="eyebrow" appLocalizationPopupDirective localizationCode="Reports">
                        {{ 'Reports' | translate: {Default: 'Reports'} }}
                    </span>
                    <h1 appLocalizationPopupDirective localizationCode="ReportGroup">
                        {{ 'ReportGroup' | translate: {Default: "Report Group"} }} - {{ reportType }}
                    </h1>
                </div>
            </div>

            <div class="header-actions">
                <button
                    class="back-button"
                    mat-stroked-button
                    appPreventDoubleClick
                    (throttledClick)="backToReportGroups()"
                    matTooltip="{{ 'BackToReports' | translate: {Default: 'Back to Reports'} }}"
                    appLocalizationPopupDirective
                    localizationCode="BackToReports"
                >
                    <mat-icon aria-hidden="false" class="material-icons-outlined">arrow_back</mat-icon>
                    {{ 'BackToReports' | translate: {Default: 'Back to reports'} }}
                </button>
            </div>
        </mat-toolbar>

        <div class="content-shell">
            <app-custom-reports-data-grid
                [reportType]="reportType"
            ></app-custom-reports-data-grid>
        </div>
    </div>
</app-layout>
